import api from "./api";
import { ComponentType } from "../components/References/Components/componentType";
export type DeleteComponentDto = {
  id: number | string;
};

/*Search & filter */
export const getComponentsApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/components?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};

/*select */

export const getComponentsDropdown = async () => {
  return await api.get("/components/dropdown");
};

// export const getComponents = async () => {
//   return await api.get("/components");
// };

export const deleteComponent = async (dto: DeleteComponentDto) => {
  return await api.delete(`/components/${dto.id}`);
};
export const getComponentById = async (componentId: string | undefined) => {
  return await api.get(`/components/${componentId}`);
};
export const createComponent = async (componentDetails: ComponentType) => {
  return await api.post("/components", componentDetails);
};
export const editComponent = async (componentId: any, body: ComponentType) => {
  return await api.put(`/components/${componentId}`, body);
};
